/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_CodeInputs */

const en_us2_clubs_field_code = /** @type {(inputs: Clubs_Field_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code`)
};

const pt_br2_clubs_field_code = /** @type {(inputs: Clubs_Field_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código do convite`)
};

const es_419_clubs_field_code = /** @type {(inputs: Clubs_Field_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de invitación`)
};

const pt_pt2_clubs_field_code = /** @type {(inputs: Clubs_Field_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código do convite`)
};

const fr_fr2_clubs_field_code = /** @type {(inputs: Clubs_Field_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code d'invitation`)
};

const de_de2_clubs_field_code = /** @type {(inputs: Clubs_Field_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungscode`)
};

const it_it2_clubs_field_code = /** @type {(inputs: Clubs_Field_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice invito`)
};

/**
* | output |
* | --- |
* | "Invite code" |
*
* @param {Clubs_Field_CodeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_code = /** @type {((inputs?: Clubs_Field_CodeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_CodeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_code(inputs)
	if (locale === "es-419") return es_419_clubs_field_code(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_code(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_code(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_code(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_code(inputs)
	return en_us2_clubs_field_code(inputs)
});
export { clubs_field_code as "clubs.field_code" }